import "antd/dist/antd.css"
import "font-awesome/css/font-awesome.css"

import React from "react"
import dialogs, { BaseDialog } from '../BaseDialogs/BaseDialogs'
import swal from 'sweetalert';

import ShareDialogs from './ShareDialogs'

import './ShareMenuModal.scss'

import { LWF } from "../../../services/external"

LWF.init()

export default { open }

function open(href) {
    if (navigator.share) {
        navigator.share({
            title: document.title,
            text: '',
            url: href
        })
    }
    else {
        dialogs.open(
            <BaseDialog title='Compartilhar com'>
                <button className='share-menu-modal-item' onClick={() => shareWithWhatsapp(href)}>
                    <i className='fa fa-whatsapp'></i> Whatsapp
                </button>
                <button className='share-menu-modal-item' onClick={() => shareWithFacebook(href)}>
                    <i className='fa fa-facebook'></i> Facebook
                </button>
            </BaseDialog>
        )
    }
}

function shareWithWhatsapp(href) {
    if (!href) {
        return
    }
    ShareDialogs.openWhatsapp({ href })
}

function shareWithFacebook(href) {
    if (!href) {
        return
    }

    window.FB.ui({
        method: 'share',
        quote: '',
        href
    }, function (response) { console.log(response) });
    swal.close()
}
